"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FilterItemType;
(function (FilterItemType) {
    FilterItemType[FilterItemType["CATEGORY_DATE"] = 0] = "CATEGORY_DATE";
    FilterItemType[FilterItemType["CATEGORY_CURRENCY"] = 1] = "CATEGORY_CURRENCY";
    FilterItemType[FilterItemType["CATEGORY_DOCUMENT"] = 2] = "CATEGORY_DOCUMENT";
    FilterItemType[FilterItemType["CATEGORY_STANDARD"] = 3] = "CATEGORY_STANDARD";
    FilterItemType[FilterItemType["CATEGORY_ME_ASSETS"] = 4] = "CATEGORY_ME_ASSETS";
    FilterItemType[FilterItemType["CATEGORY_YEAR"] = 5] = "CATEGORY_YEAR";
    FilterItemType[FilterItemType["CATEGORY_SEMI_ANNUAL"] = 6] = "CATEGORY_SEMI_ANNUAL";
    FilterItemType[FilterItemType["CATEGORY_QUARTER"] = 7] = "CATEGORY_QUARTER";
    FilterItemType[FilterItemType["CATEGORY_MONTH"] = 8] = "CATEGORY_MONTH";
    FilterItemType[FilterItemType["CATEGORY_WEEK"] = 9] = "CATEGORY_WEEK";
    FilterItemType[FilterItemType["CATEGORY_DAY"] = 10] = "CATEGORY_DAY";
    FilterItemType[FilterItemType["MEASURE_BOOLEAN"] = 11] = "MEASURE_BOOLEAN";
    FilterItemType[FilterItemType["MEASURE_DATE"] = 12] = "MEASURE_DATE";
    FilterItemType[FilterItemType["MEASURE_MONEY"] = 13] = "MEASURE_MONEY";
    FilterItemType[FilterItemType["MEASURE_NUMBER"] = 14] = "MEASURE_NUMBER";
    FilterItemType[FilterItemType["MEASURE_TEXT"] = 15] = "MEASURE_TEXT";
})(FilterItemType = exports.FilterItemType || (exports.FilterItemType = {}));
//# sourceMappingURL=filter-item-type.js.map